import React from "react";
import { useStateValue } from "../../context/StateProvider";
import { motion } from "framer-motion";
import { MdAddShoppingCart } from "react-icons/md";
import { FoodItem, CartItem } from "../../../types";
import { addToCart } from "../../utils/cart";
import { toast } from "react-toastify";

const Action = ({ food }: { food: FoodItem }) => {
    const [{ cartItems, foodItems, user }, dispatch] = useStateValue();

    const handleAddToCart = () => {
        // Проверяем, сколько уже таких позиций в корзине
        const existingItem = cartItems.find((item: CartItem) => item.fid === food.id);
        const currentQuantity = existingItem ? existingItem.quantity : 0;

        // Проверка: нельзя добавить больше 10 штук одной позиции
        if (currentQuantity >= 10) {
            toast.warning('Нельзя добавить больше 10 штук одной позиции');
            return;
        }

        // Проверка: нельзя добавить больше 20 позиций всего
        const totalItems = cartItems.reduce((acc: number, curr: CartItem) => acc + curr.quantity, 0);
        if (totalItems >= 20) {
            toast.warning('Нельзя добавить больше 20 позиций в один заказ');
            return;
        }

        addToCart(cartItems, foodItems, food.id, dispatch);
    };

    return (
        <div className="flex flex-col gap-2">
            <motion.div
                whileTap={{ scale: 1.1 }}
                whileHover={{ scale: 1.2 }}
                className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-buttonColor flex items-center justify-center cursor-pointer hover:bg-buttonColor/80 transition-colors"
                onClick={handleAddToCart}
                title="Добавить в корзину"
            >
                <MdAddShoppingCart className="text-white md:text-xl" />
            </motion.div>
        </div>
    );
};

export default Action;